import { CommonModule } from '@angular/common';
import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { IonCol, IonIcon, IonRow } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { EAvailabilityState, IFreightAvailableDetailed } from '@okcargo-apps/shared-domain';
import { DateFnsModule } from 'ngx-date-fns';

@Component({
  selector: 'lib-freight-available-detail-modal-data',
  templateUrl: './freight-available-detail-modal-data.component.html',
  styleUrls: ['./freight-available-detail-modal-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, IonRow, IonCol, IonIcon, DateFnsModule, TranslateModule],
})
export class FreightAvailableDetailModalDataComponent {
  public readonly freight = input.required<IFreightAvailableDetailed>();

  protected readonly isFullyAvailable = computed(() => {
    return this.freight().available === EAvailabilityState.FULL;
  });

  protected readonly isAvailableWithConditions = computed(() => {
    return this.freight().available === EAvailabilityState.PARTIAL;
  });

  protected readonly isNotAvailable = computed(() => {
    return this.freight().available === EAvailabilityState.NO;
  });
}
